import React from 'react';
import styled from 'styled-components';

type LabelWeight =
  | 100
  | 200
  | 300
  | 400
  | 500
  | 600
  | 700
  | 800
  | 900
  | 'bold'
  | 'bolder'
  | 'lighter'
  | 'normal';

const Container = styled('label')`
  display: flex;
  flex-flow: column nowrap;
  gap: 4px;
`;

const Label = styled('span')<{ $weight?: LabelWeight; $size?: 'small' | 'middle' | 'large' }>`
  font-weight: ${({ $weight }) => ($weight === 'bold' ? 'bold' : 'normal')};
  font-size: ${({ $size }) => ($size === 'small' ? '12px' : $size === 'middle' ? '14px' : '18px')};
  page-break-before: auto;
  -webkit-page-break-before: auto;
  -moz-page-break-before: auto;

  page-break-inside: avoid;
  -webkit-page-break-inside: avoid;
  -moz-page-break-inside: avoid;
`;

interface FieldProps {
  label: React.ReactNode;
  weight?: LabelWeight;
  size?: 'small' | 'middle' | 'large';
  inputContent: React.ReactNode;
}

const Field: React.FC<FieldProps> = ({ label, inputContent, weight = 'bold', size = 'middle' }) => {
  return (
    <Container>
      <Label $weight={weight} $size={size}>
        {label}
      </Label>
      <div>{inputContent}</div>
    </Container>
  );
};

export default Field;
